// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__3E6dn","alertIcon":"ConfirmModal_alertIcon__2dvEW"};